import { RouteConfig } from 'vue-router'

const Rabbit = () => import('../activity/medal-challenge/RabbitTravel.vue')

export const RabbitRoute: RouteConfig = {
  path: '/activity/medal-challenge-rabbit-travel',
  name: 'medal_chllenge_rabbit_travel',
  component: Rabbit,
}

export default [RabbitRoute]
